const { detect } = require('detect-browser');
const browser = detect();

window.detectedBrowser = browser;

const browserName = browser.name;
// const browserName = 'ios';
// const browserName = 'safari';

const browserOs = browser.os;

const map = {
    '/img/lottie/home_01.json': [
        '/img/home-animation-replacements/HeroSection_01-2.png',
        '/img/home-animation-replacements/HeroSection_02.png',
    ],
    '/img/lottie/home_02.json': [
        '/img/home-animation-replacements/HeroSection_03-2.png',
        '/img/home-animation-replacements/HeroSection_04.png',
    ],
    '/img/lottie/home_03.json': [
        '/img/home-animation-replacements/HeroSection_05-2.png',
        '/img/home-animation-replacements/HeroSection_06.png',
    ],
};

$(document).ready(function () {
    if (window.location.href.indexOf('do-debug') !== -1) {
        alert(JSON.stringify(browser));
    }

    if (
        browser && (['safari', 'ios'].includes(browserName) || ['iOS'].includes(browserOs))
        || window.location.href.indexOf('test-safari') !== -1
    ) {
        $('body').addClass('adjusted-for-safari');

        const lotties = $('.lottie-step-animation');

        lotties.each(function () {
            const $this = $(this);

            let src = $this.attr('src');
            console.log({ src });
            src = src.replace(/\?v\d+/, '');
            console.log({ src });

            const exchange = map[src] || null;
            console.log({ exchange});

            if (exchange) {
                const $parent = $this.parent();

                let $img1 = $('<img/>');
                let $img2 = $('<img/>');

                $img1.addClass('home-animation-replacement-img');
                $img2.addClass('home-animation-replacement-img');

                $img1.attr('src', exchange[0]);
                $img2.attr('src', exchange[1]);

                $img1.css('transition', 'none');
                $img2.css('transition', 'none');

                $img1.css('position', 'absolute');

                $img1.hide();
                $img2.hide();

                $parent.append($img1);
                $parent.append($img2);
                $parent.css('padding-top', '4rem');

                if (src === '/img/lottie/home_01.json') {
                    $img1.fadeIn(1500);
                    setTimeout(function () {
                        $img2.fadeIn(1500);
                    }, 1000);
                }
            }

            $this.remove();
        });
    }
});
